import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import Translate from 'translate';
import async from 'async';

import ChannelCaseService from 'services/ChannelCaseService';
import { FormGroup, Text, Textarea, Select } from 'components/FormElements';
import { toggleAlertError, toggleLoading } from 'stores/actions';
import { required, validFixedLine } from 'constants/InputErrors';
import IncmsService from 'services/IncmsService';

class AddImsModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      options: {},
      landmark: null
    };

    this.submitForm = this.submitForm.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if( !this.props.open && nextProps.open ) {
      this.setState( { landmark: null } );
      this.getData()
    }
  }

  getData() {
    this.props.toggleLoading( true );

    async.parallel( {
      options: ( cb ) => {
        IncmsService.getImsData().then( ( response ) => {
          if( !response.data ) return cb();
          return cb( null, {
            nature: _.orderBy( response.data.imsNature, 'nature' ),
            scope: _.orderBy( response.data.imsScope, 'scope' )
          } );

        } )
      },
      landmark: ( cb ) => {
        IncmsService.getLandmark( this.props.activeAccount.id ).then( ( response ) => {
          if( !response.data ) return cb();
          return cb( null, response.data && response.data.landmark ? response.data.landmark : null );
        } )
      }
    }, ( error, results ) => {
      this.props.toggleLoading( false );
      if( results ) this.setState( results )
    } )
  }

  submitForm( data ) {
    const { channel, onClose, onReloadData, toggleAlertError, toggleLoading } = this.props;

    toggleLoading( true );

    data.channel = channel.id;
    data.typeCase = 'ims';
    data.account = this.props.activeAccount.id;
    ChannelCaseService.saveCase( data ).then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );

      this.props.toggleAlertError( `Complaint Number: ${response.data.complaintNumber || '---'}. Account number: ${response.data.accountNumber || '---'}`, response.data.complaintNumber );
      onReloadData( channel.id );
      onClose()
    } )
  }

  render() {
    const { onClose, open } = this.props;

    return (
      <Modal closeOnEsc={false}
             closeOnOverlayClick={false}
             little
             modalClassName="col-md-6"
             open={open}
             onClose={onClose}>
        <h5 className="mt-0"><Translate id="addIMS"/></h5>

        <Form onSubmit={this.submitForm}
              defaultValues={{ imsLandmark: this.state.landmark }}
              validate={( values ) => ( {
                phoneNumber: required( values.phoneNumber ),
                imsNature: required( values.imsNature ),
                imsScope: required( values.imsScope ),
                registerComment: required( values.registerComment ),
                imsLandmark: required( values.imsLandmark ),
              } )}
        >
          {( { getValue, submitForm } ) =>
            <form onSubmit={submitForm}>
              <div className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="phone"/></label>
                  <Text field="phoneNumber" className="form-control"/>
                </FormGroup>
              </div>

              <div className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="imsNature"/></label>
                  <Select field="imsNature" className="form-control" placeholder=""
                          labelKey="nature"
                          options={this.state.options.nature}/>
                </FormGroup>

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="imsScope"/></label>
                  <Select field="imsScope" className="form-control" placeholder=""
                          labelKey="scope"
                          options={this.state.options.scope}/>
                </FormGroup>
              </div>

              <FormGroup>
                <label><Translate id="imsComment"/></label>
                <Textarea field="registerComment" className="form-control"/>
              </FormGroup>


              <div className="row">
                <FormGroup containerClass="col-md-12">
                  <label><Translate id="landmark"/></label>
                  <Textarea field="imsLandmark" className="form-control"/>
                </FormGroup>
              </div>

              <div className="text-right">
                <button className="btn btn-info"><Translate id="submit"/></button>
              </div>
            </form>
          }
        </Form>
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message, msgToCopy ) => {
    dispatch( toggleAlertError( message, msgToCopy ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( AddImsModal );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/AddImsModal/index.js